(function() {

    document.addEventListener("DOMContentLoaded", function () {        
        document.querySelectorAll('.header-landing-block').forEach(block => {
            
            const container = block.querySelector('.header-landing-container');   
            const bgImageDesktop = container.dataset.bgimage;
            const bgImageMobile = container.dataset.bgimagemobile;         

            const styleTag = document.createElement("style");
            styleTag.innerHTML = `
                .header-landing-container {
                    background-image: url(${bgImageDesktop});
                }
                @media (max-width: 768px) {
                    .header-landing-container {
                        background-image: url(${bgImageMobile});
                    }
                }
            `;

            document.head.appendChild(styleTag);
            
        });

    });

    document.addEventListener(window.AseguraGoConstants.ASEGURAGO_CALLME_FORM_SUBMITED_EVENT, (event) => {
        document.querySelectorAll('.header-landing-block').forEach(block => {          
            const formWrapper = block.querySelector('.header-landing-form-wrapper');
            if ( formWrapper ) {
                formWrapper.querySelector('.header-landing-form-container').classList.add('hidden');
                formWrapper.querySelector('.shared-callme-success-wrapper').classList.remove('hidden');
            }
        });
    });

    

})();